import { render } from "./ItemsTable.vue?vue&type=template&id=11c5e5fb"
import script from "./ItemsTable.vue?vue&type=script&lang=js"
export * from "./ItemsTable.vue?vue&type=script&lang=js"

import "./ItemsTable.vue?vue&type=style&index=0&id=11c5e5fb&lang=css"

import exportComponent from "/home/oawms/app/ru_releases/20261004163500/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QItemSection,QTooltip,QCard});
